import { useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import ExcelJS from 'exceljs';

import { jsPDF } from "jspdf";
import "jspdf-autotable";

import { Card, CardContent } from "@mui/material";
import { Helmet } from "react-helmet-async";
import PostedFilterHeader from "./PostedFilterHeader";
import PostedFilterService from "./PostedFilterService";
import PostedFilterDataGrid from "./PostedFilterDataGrid";
import PostedFilterSearch from "./PostedFilterSearch";
import LoadingProgressBar from "../../components/loading-progressbar/loadingprogressbar";
import AddEntity from './AddEntity';
import EditEntity from "./EditEntity";
import PopUpHandle from "../../commons/PopUpHandle";
import { useAppStore } from "../../store/appStore";


export default function PostedFilterMaster() {






    const [isFilterOpen, setFilterOpen] = useState(false); // Define state for filter modal
    const location = useLocation();

    const [filterPayload, setFilterPayload] = useState(null);







    const [loadingCount, setLoadingCount] = useState(0);
    const showLoading = () => setLoadingCount((prev) => prev + 1);
    const hideLoading = () => setLoadingCount((prev) => Math.max(prev - 1, 0));


    const [open, setOpen] = useState(false);
    const [error, setError] = useState('');
    const [errorCode, setErrorCode] = useState(0);



    const { pageType } = useParams();

    const {
        moduleName,
        setModuleName,
        destroy,
        setSearchControls,
        searchControls,
        setResponseData,
        responseData,
        setFilteredData,
        filteredData,
        isListChanged,
        setIsListChanged,
        hoverFilterValues

    } = useAppStore();

    useEffect(() => {
        if (!location?.pathname.includes(moduleName)) {
            destroy(); //  this resets the entire store to initial state
            setResponseData({});
            setFilteredData(undefined);
            setModuleName('upload-document');
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location?.pathname]);


    const handleOpenFilter = () => {
        setFilterOpen(true);
    };

    const handleCloseFilter = () => {
        setFilterOpen(false);
    };
    const handleClose = () => {
        setOpen(false);
    }

    useEffect(() => { // NOSONAR
        const fetchDynamicUIList = async () => {
            showLoading();

            try {
                const postedFilterServiceInstance = await PostedFilterService;

                if (!postedFilterServiceInstance) {
                    throw new Error("PostedFilterService instance could not be created.");
                }

                const response = await postedFilterServiceInstance.GetDynamicUIList();
                if (response && response.data) {
                    setResponseData(response.data);
                    setIsListChanged(false);
                } else {
                    console.error("Invalid response format for GetDynamicUIList:", response);
                    setResponseData([]);
                    setIsListChanged(false);

                }
            } catch (err) {
                console.error("Error fetching Dynamic UI List:", err);
                if (err?.response?.data?.error?.message === 'Data not found.' || err?.response?.data?.error?.code === 404) {
                    //
                } else {
                    setOpen(true);
                    setError((prev) => err?.response?.data?.error?.message ?? prev);
                    setErrorCode((prev) => err?.response?.data?.error?.code ?? prev)
                }

                setResponseData([]);
                setIsListChanged(false);
            } finally {
                hideLoading();
            }
        };
        if (!pageType && isListChanged && moduleName != null) {
            fetchDynamicUIList();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleName]);

    useEffect(() => {
        const fetchDynamicUISearchControls = async () => {
            showLoading();
            try {
                const postedFilterServiceInstance = await PostedFilterService;

                if (!postedFilterServiceInstance) {
                    throw new Error("PostedFilterService instance could not be created.");
                }

                const response = await postedFilterServiceInstance.GetDynamicUISearchControls();
                if (response && response.data) {
                    setSearchControls(response.data);
                } else {
                    console.error("Invalid response format for GetDynamicUISearchControls:", response);
                    setSearchControls([]);
                }
            } catch (err) {
                console.error("Error fetching Dynamic UI Search Controls:", err);
                setSearchControls([]);
            } finally {
                hideLoading();
            }
        };

        if (!pageType && moduleName !== null && (!searchControls?.length > 0 || isListChanged) ) {
            fetchDynamicUISearchControls();
        }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [moduleName, isListChanged]);


    const getTime = () => {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = now.toLocaleString('en-US', { month: 'short' });
        const year = now.getFullYear();
        const hours = String(now.getHours()).padStart(2, '0');
        const minutes = String(now.getMinutes()).padStart(2, '0');
        const seconds = String(now.getSeconds()).padStart(2, '0');

        const timestamp = `${day}${month}${year}${hours}${minutes}${seconds}`;
        return timestamp;
    }




    const downloadExcel = async () => {
        if (!responseData) return;

        const workbook = new ExcelJS.Workbook();
        const worksheet = workbook.addWorksheet('Sheet1');

        // Set columns
        const columns = responseData.ColumnWidth.map(column => ({
            header: column.ColumnName,
            key: column.ColumnName,
            // width: column.Width || 20
        }));
        worksheet.columns = columns;

        // Add data rows
        responseData.Data.forEach((dataRow) => {
            const row = {};
            columns.forEach((col) => {
                row[col.key] = dataRow[col.key];
            });
            worksheet.addRow(row);
        });

        // Auto-fit column width based on content
        worksheet.columns.forEach((column) => {
            let maxLength = column.header.length; // Start with the header length
            column.eachCell({ includeEmpty: true }, (cell) => {
                if (cell.value) {
                    const cellValue = cell.value.toString();
                    maxLength = Math.max(maxLength, cellValue.length);
                }
            });
            column.width = maxLength + 2; // Add some padding
        });

        // Style header row
        worksheet.getRow(1).eachCell((cell) => {
            cell.font = { bold: true };
            cell.alignment = { vertical: 'center', horizontal: 'center' };
            cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFC5D9F1' } };
        });

        // Style body rows
        worksheet.eachRow({ includeEmpty: true }, (row, rowNumber) => {
            if (rowNumber !== 1) {
                row.eachCell({ includeEmpty: true }, (cell) => {
                    cell.alignment = { vertical: 'center', horizontal: 'left', wrapText: true };
                    cell.border = {
                        top: { style: 'thin', },
                        left: { style: 'thin' },
                        bottom: { style: 'thin' },
                        right: { style: 'thin' },
                    };
                });
            }
        });



        // Generate and download the Excel file
        const buffer = await workbook.xlsx.writeBuffer();
        const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
      const timeStamp = new Date().toISOString().replace(/[:\-T]/g, '').slice(0, 15);
        link.download = `PostedFilter_${timeStamp}.xlsx`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };


    

    const exportToPDF = () => {
        if (!responseData.Data || !responseData.ColumnWidth) return;

        // Extract columns and rows
        const columns = responseData.ColumnWidth.map(col => col.ColumnName).filter(name => name !== "Id");
        const rows = responseData.Data.map(row => columns.map(col => row[col] || ""));

        // Generate PDF
        // eslint-disable-next-line new-cap
        const doc = new jsPDF();
        doc.autoTable({
            head: [columns],
            body: rows,
        });

        doc.save(`PostedFilter_${getTime()}.pdf`);
    };

     //  console.log("pageType: ", pageType);

    
    return (
        <Card sx={{
            padding: '2px',
            boxShadow: '0px 2px 5px rgba(0, 0, 0, 0.1)',
            borderRadius: '10px',
            margin: '5px 3px 5px 3px',
            height: '100%',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            flex: 1,

        }}>
            <CardContent style={{
                flexGrow: 1,
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box',
                paddingBottom: '0.5rem',
                minHeight: 0
            }}>
                <Helmet>
                    <title>
                        {location.pathname.includes('posted-filter') ? 'Posted Filter' : 'Upload Document'} | ProClaimz
                    </title>
                </Helmet>
                
                {!pageType && <PostedFilterHeader headerName={location.pathname.includes('posted-filter') ? 'Posted Filter' : 'Upload Document'} exportToPDF={exportToPDF} exportToExcel={downloadExcel} handleOpenFilter={handleOpenFilter} filterValues={hoverFilterValues} /> }
                <PostedFilterSearch searchControls={searchControls} setFilterPayload={setFilterPayload} filterPayload={filterPayload}  open={isFilterOpen} onClose={handleCloseFilter} setListData={setFilteredData} showLoading={showLoading} hideLoading={hideLoading} />
                <div style={{ flex: 1 }}>
                    {!pageType && responseData && <PostedFilterDataGrid headerName={location.pathname.includes('posted-filter') ? 'Posted Filter' : 'Upload Document'} data={
                        // eslint-disable-next-line no-nested-ternary
                        filteredData === undefined // NOSONAR
                            ? responseData // NOSONAR
                            : filteredData === null // NOSONAR
                                ? { ...responseData, Data: [] } // NOSONAR
                                : filteredData // NOSONAR
                    } /> }
                </div>
                {pageType === 'add' && <AddEntity headerName={location.pathname.includes('posted-filter') ? 'Posted Filter' : 'Upload Document'} />}
                {pageType === 'edit' && <EditEntity headerName={location.pathname.includes('posted-filter') ? 'Posted Filter' : 'Upload Document'} />}
                {loadingCount > 0 && <LoadingProgressBar />}
                {open && <PopUpHandle open={open} handleClose={handleClose} error={error} errorCode={errorCode} />}

            </CardContent>
        </Card>
    )
}